import { motion } from "framer-motion";
import { Cpu, Sparkles, Zap, Wand2 } from "lucide-react";

const items = [
    // {
    //     icon: Cpu,
    //     title: "Reasons across the company",
    //     body: "“Why did Q4 pipeline slip?” — answers cite the deals, tasks and docs that explain it.",
    // },
    // {
    //     icon: Wand2,
    //     title: "Drafts the next move",
    //     body: "Briefs, SOPs, follow‑ups and project plans — generated with full operating context.",
    // },
    // {
    //     icon: Zap,
    //     title: "Acts inside your workflows",
    //     body: "Natural‑language automations trigger across Sales, Ops, HR and Projects in seconds.",
    // },
];

export const AIAutomation = () => {
    return (
        <section
            id="automation"
            className="relative py-24 sm:py-32 overflow-hidden"
            data-testid="ai-automation-section"
        >
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-electric/40 to-transparent" />
            <div className="absolute inset-0 radial-glow opacity-60 pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                    <div className="lg:col-span-5">
                        <div className="inline-flex items-center gap-2 glass rounded-full px-3 py-1 mb-6">
                            <Sparkles className="w-3.5 h-3.5 text-amber-glow" />
                            <span className="text-[11px] uppercase tracking-[0.2em] font-semibold text-zinc-300">
                                ApexBrain Intelligence
                            </span>
                        </div>
                        <p className="text-xs uppercase tracking-[0.25em] text-amber-glow font-semibold mb-4 font-code">
                            // intelligence beyond dashboards
                        </p>
                        <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-[1.05]">
                            A brain that runs
                            <br />
                            <span className="gradient-text-amber">
                                with your company.
                            </span>
                        </h2>
                        <p className="mt-6 text-zinc-400 text-base sm:text-lg font-light leading-relaxed">
                            Dashboards show you charts. ApexBrain understands them —
                            connecting people, projects, customers and cash into a
                            single reasoning layer that explains the business and
                            quietly improves it.
                        </p>

                        <div className="mt-10 space-y-3">
                            {items.map((it, i) => (
                                <motion.div
                                    key={it.title}
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: i * 0.08 }}
                                    className="flex gap-4 p-4 rounded-xl border border-white/[0.06] hover:border-white/15 hover:bg-white/[0.02] transition"
                                    data-testid={`ai-item-${i}`}
                                >
                                    <div className="shrink-0 w-9 h-9 rounded-lg bg-electric/10 border border-electric/20 flex items-center justify-center">
                                        <it.icon className="w-4 h-4 text-electric" />
                                    </div>
                                    <div>
                                        <div className="font-outfit text-base font-semibold text-white">
                                            {it.title}
                                        </div>
                                        <div className="text-sm text-zinc-400 mt-1 leading-relaxed">
                                            {it.body}
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    {/* Mock AI panel */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        className="lg:col-span-7"
                    >
                        <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-gradient-to-br from-obsidian-100 to-obsidian-300 p-6 sm:p-8 shadow-[0_40px_120px_-20px_rgba(59,130,246,0.4)]">
                            <div className="flex items-center gap-2 mb-6">
                                <span className="w-2.5 h-2.5 rounded-full bg-zinc-700" />
                                <span className="w-2.5 h-2.5 rounded-full bg-zinc-700" />
                                <span className="w-2.5 h-2.5 rounded-full bg-zinc-700" />
                                <span className="ml-3 text-xs font-mono text-zinc-500">
                                    apexbrain.ai/co‑pilot
                                </span>
                            </div>

                            <div className="space-y-4">
                                <div className="flex justify-end">
                                    <div className="max-w-md bg-electric text-white text-sm rounded-2xl rounded-br-sm px-4 py-3 font-medium">
                                        Summarize this week's pipeline & draft a
                                        Slack update for #sales.
                                    </div>
                                </div>

                                <div className="flex gap-3">
                                    <div className="shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-amber-glow to-amber-700 flex items-center justify-center">
                                        <Sparkles className="w-3.5 h-3.5 text-black" />
                                    </div>
                                    <div className="flex-1 max-w-xl glass rounded-2xl rounded-tl-sm px-4 py-3">
                                        <p className="text-sm text-zinc-200 leading-relaxed">
                                            <span className="text-amber-glow font-semibold">
                                                Pipeline: $1.42M
                                            </span>{" "}
                                            (+12.4% WoW). 3 deals in late stage
                                            ($340k). Acme & Stripe likely to
                                            close.
                                        </p>
                                        <div className="mt-3 grid grid-cols-3 gap-2">
                                            {[
                                                {
                                                    k: "New",
                                                    v: 24,
                                                },
                                                {
                                                    k: "Won",
                                                    v: 7,
                                                },
                                                {
                                                    k: "Lost",
                                                    v: 2,
                                                },
                                            ].map((m) => (
                                                <div
                                                    key={m.k}
                                                    className="rounded-lg bg-white/5 border border-white/10 px-3 py-2"
                                                >
                                                    <div className="text-[9px] uppercase tracking-wider text-zinc-500">
                                                        {m.k}
                                                    </div>
                                                    <div className="font-outfit text-sm font-bold text-white tabular-nums">
                                                        {m.v}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="mt-3 flex flex-wrap gap-2">
                                            <button className="text-[11px] font-semibold px-3 py-1.5 rounded-full bg-electric text-white hover:brightness-110 transition">
                                                Post to #sales
                                            </button>
                                            <button className="text-[11px] font-semibold px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-zinc-300 hover:bg-white/10 transition">
                                                Open in CRM
                                            </button>
                                            <button className="text-[11px] font-semibold px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-zinc-300 hover:bg-white/10 transition">
                                                Schedule recap
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
